import { useState, useEffect } from "react";
import { fetchHospitalDetails } from "utils/apiHelper";

export const useDebounce = (value, delay = 300, minLength = 1) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    if (value.length < minLength) {
      setDebouncedValue("");
      return;
    }
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, delay]);

  return debouncedValue;
};

export const useHospitalDetails = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchHospitalDetails().then(setData).catch(console.error);
  }, []);

  return data;
};